import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../config";
import { authFetch } from "../utility/AuthFetch";

function MarksEntry() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [standard, setStandard] = useState("");
  const [standardList, setStandardList] = useState([]);
  const [standardSelected, setStandardSelected] = useState(false);
  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);
  const [divSelected, setDivSelected] = useState(false);
  const [type, setType] = useState("");
  const [typeSelected, setTypeSelected] = useState(false);
  const [examName, setExamName] = useState("");
  const [examNameList, setExamNameList] = useState([]);
  const [examNameSelected, setExamNameSelected] = useState(false);
  const [maxMarks, setMaxMarks] = useState("");
  const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [subjectSelected, setSubjectSelected] = useState(false);
  const [studentList, setStudentList] = useState([]);

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setDiv("");
    setDivSelected(false);
    setType("");
    setTypeSelected(false);
    setExamName("");
    setExamNameList([]);
    setExamNameSelected(false);
    setSubject("");
    setSubjectSelected(false);
    setSubjectList([]);
    if (standard === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`
      );
      const result = await response.json();
      setDivList(result.division);
      setStandardSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setStandardSelected(false);
    }
  };

  const fetchExamName = async (type) => {
    setExamName("");
    setExamNameList([]);
    setExamNameSelected(false);
    setSubject("");
    setSubjectSelected(false);
    setSubjectList([]);
    if (type === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/exam-category-options?query=${type}`
      );
      const result = await response.json();
      setExamNameList(result.exam_categories);
      setTypeSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setTypeSelected(false);
    }
  };

  const fetchSubject = async () => {
    setStudentList([]);
    if (standard === "" || div === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/subject-options?standard=${standard}`
      );
      const result = await response.json();
      setSubjectList(result.subjects);
      setExamNameSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setExamNameSelected(false);
    }
  };

  const fetchStudents = async (subject) => {
    if (type === "Internal Assessment") {
      setMaxMarks(
        examNameList.find((item) => item.id === Number(examName))?.maxMarks / 5
      );
    } else {
      setMaxMarks(
        examNameList.find((item) => item.id === Number(examName))?.maxMarks
      );
    }
    setStudentList([]);
    if (subject === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/student?standard=${standard}&div=${div}&name=${examName}&subject=${subject}`
      );
      const result = await response.json();
      setStudentList(result.student);
      setSubjectSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setSubjectSelected(false);
    }
  };

  const handleMarksChange = (index, value, col) => {
    const updated = [...studentList];
    if (col === "classWork") {
      updated[index].classWork = value;
    } else if (col === "homeWork") {
      updated[index].homeWork = value;
    } else if (col === "subEnrichment") {
      updated[index].subEnrichment = value;
    } else if (col === "discipline") {
      updated[index].discipline = value;
    } else if (col === "classInvolvement") {
      updated[index].classInvolvement = value;
    } else {
      updated[index].marks = value;
    }
    setStudentList(updated);
  };

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    studentList.forEach((s, index) => {
      formData.append(`marks[${s.id}]`, s.marks);
      formData.append(`classWork[${s.id}]`, s.classWork);
      formData.append(`homeWork[${s.id}]`, s.homeWork);
      formData.append(`subEnrichment[${s.id}]`, s.subEnrichment);
      formData.append(`discipline[${s.id}]`, s.discipline);
      formData.append(`classInvolvement[${s.id}]`, s.classInvolvement);
    });

    const url = `${API_BASE_URL}/api/add-marks`;

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Marks added successfully");
        formRef.current.reset();
        setStandard("");
        setStandardSelected(false);
        setDiv("");
        setDivList([]);
        setDivSelected(false);
        setType("");
        setTypeSelected(false);
        setExamName("");
        setExamNameList([]);
        setExamNameSelected(false);
        setSubject("");
        setSubjectSelected(false);
        setSubjectList([]);
        setIsSubmitting(false);
        setLoader(false);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Marks Entry</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="class"
                      required
                      value={standard}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Class
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {standardSelected && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>
                          Section <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          value={div}
                          onChange={(e) => {
                            setDiv(e.target.value);
                            setTypeSelected(false);
                            setDivSelected(true);
                          }}
                          required
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {divSelected && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formType">
                            <Form.Label>
                              Exam Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="type"
                              value={type}
                              onChange={(e) => {
                                const value = e.target.value;
                                setType(value);
                                fetchExamName(value);
                              }}
                              required
                            >
                              <option value="" disabled>
                                Select Exam Type
                              </option>
                              <option value="Periodic Test">
                                Periodic Test
                              </option>
                              <option value="Internal Assessment">
                                Internal Assessment
                              </option>
                              <option value="Half Yearly">Half Yearly</option>
                              <option value="Annual Exam">Annual Exam</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        {typeSelected && (
                          <>
                            <Col md={4}>
                              <Form.Group className="mb-3" controlId="formType">
                                <Form.Label>
                                  Exam Name
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                  name="name"
                                  value={examName}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setExamName(value);
                                    fetchSubject();
                                  }}
                                  required
                                >
                                  <option value="" disabled>
                                    Select Exam
                                  </option>
                                  {examNameList?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            {examNameSelected && (
                              <>
                                <Col md={4}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formType"
                                  >
                                    <Form.Label>
                                      Subject Name
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="subject"
                                      value={subject}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setSubject(value);
                                        fetchStudents(value);
                                      }}
                                      required
                                    >
                                      <option value="" disabled>
                                        Select Subject
                                      </option>
                                      {subjectList?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.Name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                                {subjectSelected && (
                                  <Table striped bordered hover id="marksTable">
                                    <thead>
                                      <tr>
                                        <th>NAME</th>
                                        <th>ROLL No.</th>
                                        <th>ADMISSION No.</th>
                                        <th>MAX MARKS</th>
                                        {type === "Internal Assessment" ? (
                                          <>
                                            <th>CLASS WORK</th>
                                            <th>HOME WORK</th>
                                            <th>SUB ENRICHMENT</th>
                                            <th>DISCIPLINE</th>
                                            <th>CLASS INVOLVEMENT</th>
                                          </>
                                        ) : (
                                          <th>MARKS OBTAINED</th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {studentList?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.name}</td>
                                          <td>{item.roll}</td>
                                          <td>{item.admission}</td>
                                          <td>{maxMarks}</td>
                                          {type === "Internal Assessment" ? (
                                            <>
                                              <td>
                                                <Form.Control
                                                  type="number"
                                                  step="0.5"
                                                  max={maxMarks}
                                                  min={0}
                                                  value={item.classWork}
                                                  onChange={(e) => {
                                                    handleMarksChange(
                                                      index,
                                                      e.target.value,
                                                      "classWork"
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="number"
                                                  step="0.5"
                                                  max={maxMarks}
                                                  min={0}
                                                  value={item.homeWork}
                                                  onChange={(e) => {
                                                    handleMarksChange(
                                                      index,
                                                      e.target.value,
                                                      "homeWork"
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="number"
                                                  step="0.5"
                                                  max={maxMarks}
                                                  min={0}
                                                  value={item.subEnrichment}
                                                  onChange={(e) => {
                                                    handleMarksChange(
                                                      index,
                                                      e.target.value,
                                                      "subEnrichment"
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="number"
                                                  step="0.5"
                                                  max={maxMarks}
                                                  min={0}
                                                  value={item.discipline}
                                                  onChange={(e) => {
                                                    handleMarksChange(
                                                      index,
                                                      e.target.value,
                                                      "discipline"
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  type="number"
                                                  step="0.5"
                                                  max={maxMarks}
                                                  min={0}
                                                  value={item.classInvolvement}
                                                  onChange={(e) => {
                                                    handleMarksChange(
                                                      index,
                                                      e.target.value,
                                                      "classInvolvement"
                                                    );
                                                  }}
                                                />
                                              </td>
                                            </>
                                          ) : (
                                            <td>
                                              <Form.Control
                                                type="number"
                                                step="0.5"
                                                max={maxMarks}
                                                min={0}
                                                value={item.marks}
                                                onChange={(e) => {
                                                  handleMarksChange(
                                                    index,
                                                    e.target.value,
                                                    "marks"
                                                  );
                                                }}
                                              />
                                            </td>
                                          )}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Row>

              {subjectSelected && (
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  SUBMIT
                </Button>
              )}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarksEntry;
